import { useState } from 'react';

import loadingImage from 'utils/images/loadingImage';
import useMount from 'hooks/common/useMount';

const useLoadingImage = (url: string) => {
  const [image, setImage] = useState<HTMLImageElement>();

  useMount(() => {
    const getImage = async () => {
      const img = await loadingImage(url);
      setImage(img);
    };
    getImage();
  });

  return image;
};

export default useLoadingImage;
